import * as path from "path";

/**
 * Converts a file path to a proper file URI for cross-platform compatibility
 * @param p - The file path to convert
 * @returns A properly formatted file URI
 */
export function toFileUri(p: string): string {
  const resolvedPath = path.resolve(p);

  // Normalize path separators to forward slashes
  let normalizedPath = resolvedPath.replace(/\\/g, "/");

  // Handle Windows drive letters (e.g., C: -> /C:)
  if (/^[a-zA-Z]:/.test(normalizedPath)) {
    normalizedPath = "/" + normalizedPath;
  }

  // Ensure path starts with / for absolute paths
  if (!normalizedPath.startsWith("/")) {
    normalizedPath = "/" + normalizedPath;
  }

  return `file://${normalizedPath}`;
}

/**
 * Converts a file URI back to a file path for cross-platform compatibility
 * @param uri - The file URI to convert
 * @returns A properly formatted file path
 */
export function fileUriToPath(uri: string): string {
  // Handle file URI properly for cross-platform compatibility
  let filePath = uri;

  // Remove file:// prefix
  if (filePath.startsWith("file://")) {
    filePath = filePath.substring(7);
  }

  // Handle Windows drive letters (remove leading slash before drive letter)
  if (process.platform === "win32" && /^\/[a-zA-Z]:/.test(filePath)) {
    filePath = filePath.substring(1);
  }

  // Decode URI components and normalize path separators
  filePath = decodeURIComponent(filePath);
  filePath = filePath.replace(/\//g, path.sep);

  return filePath;
}
